<template>
  <div class="lg:flex lg:flex-row-reverse lg:h-screen">
    <Map ref="map" class="h-64 lg:h-full lg:flex-1" />
    <div :class="sidebarExpanded ? 'lg:w-3/5' : 'lg:w-2/5'">
      <TransitionFadeSlideUp>
        <SvgCompassLoader :animated="true" v-if="loading" class="h-24 w-24 mt-48 mx-auto" />
        <SidebarMobile v-else-if="isMobile" :estimate-loading="estimateLoading" />
        <Sidebar
          v-else
          :estimate-loading="estimateLoading"
          :expanded="sidebarExpanded"
          @expandClick="handleSidebarExpandClick"
        />
      </TransitionFadeSlideUp>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import { get, sync, call } from 'vuex-pathify'
import TransitionFadeSlideUp from '@/components/transitions/FadeSlideUp'
import SvgCompassLoader from '@/components/svg/CompassLoader'
import Sidebar from '@/components/Sidebar'
import SidebarMobile from '@/components/SidebarMobile'
import Map from '@/components/Map'
import { getAirport } from '@/services/api'
import URLSearchParams from '@ungap/url-search-params'

export default {
  components: { TransitionFadeSlideUp, SvgCompassLoader, Sidebar, SidebarMobile, Map },
  data () {
    return {
      // Tailwind lg breakpoint
      isMobile: window.innerWidth < 1024,
      loading: true,
      estimateLoading: false,
      queryRedirect: false,
      sidebarExpanded: true,
    }
  },
  computed: {
    ...sync('explorer/', ['fromAirport', 'toAirport', 'estimate', 'places', 'suggestedAirports', 'order']),
  },
  watch: {
    fromAirport: {
      immediate: true,
      handler () { this.airportHandler() }
    },
    toAirport: {
      immediate: true,
      handler () { this.airportHandler() }
    },
  },
  async created () {
    window.onpopstate = async (e) => {
      this.queryRedirect = true
      await this.handleQueryParams()
      this.queryRedirect = false
    }

    window.addEventListener('resize', this.handleResize)

    await this.handleQueryParams()

    this.loading = false

    // Fetch geo IP for location biasing
    this.fetchUserLocation()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...call('explorer/', ['fetchUserLocation', 'fetchFlightEstimate']),
    handleResize (e) {
      this.isMobile = e.target.innerWidth < 1024
    },
    async handleQueryParams () {
      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has('from')) {
        const { data } = await getAirport(urlParams.get('from'))
        this.fromAirport = data
      } else {
        this.fromAirport = null
      }
      if (urlParams.has('to')) {
        const { data } = await getAirport(urlParams.get('to'))
        this.toAirport = data
      } else {
        this.toAirport = null
      }

      if (this.toAirport && this.fromAirport) {
        this.loading = false
        this.airportHandler()
      }
    },
    setUrlParams (from, to) {
      const urlParams = new URLSearchParams(window.location.search)
      if (from) urlParams.set('from', from)
      else urlParams.delete('from')
      if (to) urlParams.set('to', to)
      else urlParams.delete('to')
      history.pushState(null, '', window.location.pathname + `${urlParams.toString() ? '?' + urlParams.toString() : ''}`)
    },
    async airportHandler () {
      if (this.loading) return

      if (!this.queryRedirect) {
        this.setUrlParams(this.fromAirport ? this.fromAirport.icao_code : null, this.toAirport ? this.toAirport.icao_code : null)
      }

      if (!this.fromAirport || !this.toAirport || this.fromAirport.icao_code === this.toAirport.icao_code) {
        this.estimate = null
        return
      }

      this.estimateLoading = true
      await this.fetchFlightEstimate()
      this.estimateLoading = false
      this.places = []
      this.suggestedAirports = []
      this.order = []
    },
    async handleSidebarExpandClick() {
      this.sidebarExpanded = !this.sidebarExpanded

      if (this.$refs.map) {
        await nextTick()
        this.$refs.map.map.resize()
      }
    },
  }
}
</script>
